export const m = {
	header: {
		home: 'HOME',
		company: 'GAME CENTRE',
		corporate: 'ABOUT US',
		products: 'CAREERS',
		joinus: 'CONTACT US'
	},
	home: {
		moregame: 'More Games',
		gameintro: 'PRODUCTS',
		companyintro:'ABOUT US',
		moredetail:'More details',
		aboutcompany:'ICLOCKWORK was established in 2012 with a registered capital of 10.51 million. Headquartered in Suzhou Industrial Park, it has branches in Hong Kong, Seoul and Taipei. The distribution area covers North America, Southeast Asia, HongKong, Macao, Taiwan and etc,. In 2015, the company gained investment from well-known domestic investment institutions and entered a period of rapid development. Become a leader in the field of mobile game distribution in Southeast Asia.·',
		sz:'苏州-总部',
		tw:'台北-分公司',
		xg:'香港-分公司',
		kr:'首尔-分公司',
		welcome:'WELCOME TO JOIN US',
		joinus:'Join us',
		aboutus:"The founding teams are all from well-known game companies such as, Activision Blizzard, with an average of more than 10 years' experience and rich AAA level game production and distribution experience. The team has successfully released several top 10 games in app store and Google play store in China and even around the world."
	},
	company: {
		about: 'ABOUT THE COMPANY',
		content1: 'ICLOCKWORK was established in 2012 with a registered capital of 10.51 million. Headquartered in Suzhou Industrial Park, it has branches in Hong Kong, Seoul and Taipei. The distribution area covers North America, Southeast Asia, HongKong, Macao, Taiwan and etc,. In 2015, the company gained investment from well-known domestic investment institutions and entered a period of rapid development. Become a leader in the field of mobile game distribution in Southeast Asia.·',
		content2: 'During the research and development, ICLOCKWORK focus on the important role that intellectual property right plays in the competitiveness of enterprises. By independent research and development, Industry-University-Research Collaboration, ICLOCKWORK has achieved 29 software copyrights. In 2016, ICLOCKWORK identified as a national high-tech enterprise and software enterprise. In 2018, it was identified as a provincial hidden giant enterprise and one of the enterprises in Gazelle Project. In the same year, the company founder Mr. Shao Zhen won the title of Leading Talent in Suzhou Industrial Park. In 2019, ICLOCKWORK has won the qualification of National Cultural Export Key Enterprise.',
		head: 'Headquarters',
		issuing: 'Distribution company',
		history: 'COMPANY HISTORY',
		game1: '小小主公',
		game2: '塔防三国志',
		game3: '超神学院',
		game4: '王牌制片人',
		game5: '乱斗英雄志',
		game6: '塔防三国志韩文版',
		game7: '小小主公2',
		game8: 'CODE:SEED星火之歌',
		team: 'TEAM-BUILDING',
		pic1: 'The gifts of Spring Festival',
		pic2:'Year End Party',
		pic3:'Board Game Club',
		pic4:'7th anniversary',
		pic5:'Movie Tickets',
		pic6:'Company',
		pic7:'Travel',
		pic8:'Group Photos',
		pic9:'English Class',
		sz:'Suzhou',
		xg:'Hongkong',
		tb:'Taipei',
		hg:'Korea',
		dny:'Southeast Asia',
		bm:'North America'
	},
	culture: {
		cu: 'Culture',
		cv: 'Core Values',
		td: 'Talent Development',
		we: 'Work Environment',
		ea: 'Employee Activities',
		vs: 'Vision',
		ms: 'Mission'
	},
	products: {
		gm: 'TOP-QUALITY GAMES',
		oc: 'Official'
	},
	joinus: {
		ph: 'Contact information',
		em: 'Enterprise e-mail',
		ad: 'Permanent address',
		tips:'How to deliver: Send the resume with the name of "Name+Position" to mail ',
		require:'岗位要求:',
		responsibility:'岗位职责:',
		all:'All'
	},
	footer: {
		lm: 'Learn More',
		fu: 'Follow Us',
		cu: 'Contact Us',
		li: 'Legal Information',
		lo: 'Location',
		wx: 'Weixin',
		cs: 'Customer Service',
		pa: 'Partnership',
		sa: 'Service Agreement',
		pp: 'Privacy Policy',
		ip: 'Intellectual Property'
	}
}